import { createSlice } from "@reduxjs/toolkit";

const initialState = {
  chatId: "",
  lastMessage: {},
  id: "",
  uuid: "",
  fullName: "",
};

export const messageSlice = createSlice({
  name: "message",
  initialState,
  reducers: {
    setMessage: (state, action) => {
      state.chatId = action.payload.chatId;
      state.lastMessage = action.payload.lastMessage;
      state.id = action.payload.id;
      state.uuid = action.payload.uuid;
      state.fullName = action.payload.fullName;
    },
  },
});
export const { setMessage } = messageSlice.actions;

export default messageSlice.reducer;
